module.exports = __webpack_public_path__ + "img/mokomei_title.28b90bdb.png";